export default __webpack_public_path__ + "18b5cdd7c0687818f9eac1c950c180aa.svg";